import { stringifyUnitType, UnitProfile } from "@/domain/units";
import { useState } from "react";
import { FauxDialogLayout } from "../faux-dialog-layout";
import { useRuleset } from "../game-content-provider";
import { RowData, Table } from "../table";
import * as tableCss from "../unit-profiles/style.css";

export function TargetNumbers() {
  const ruleset = useRuleset();
  const [isTableOverflowing, setIsTableOverflowing] = useState(false);

  return (
    <FauxDialogLayout heading="Target Numbers" theme="dark">
      {!isTableOverflowing && (
        <p className={tableCss.scrollHint}>Scroll horizontally to explore the table →</p>
      )}

      <div style={{ marginBlockStart: "2rem" }}>
        <Table
          size="large"
          getItemDataKey={(i) => i.type}
          onTableOverflow={setIsTableOverflowing}
          columns={[
            {
              label: "Unit Attacking",
              key: "attacking",
              width: "15%",
              align: "left",
              sticky: true,
              getRowData: (unitProfile) => {
                return {
                  align: "left",
                  sticky: true,
                  heading: true,
                  value: stringifyUnitType(unitProfile.type),
                };
              },
            },
            ...ruleset.unitProfiles.map((columnUnitProfile) => {
              return {
                label: stringifyUnitType(columnUnitProfile.type),
                key: columnUnitProfile.type,
                getRowData: (unitProfile: UnitProfile): RowData => ({
                  value: `${unitProfile.targetScores.find((score) => score.vsType === columnUnitProfile.type)?.minScore}+`,
                }),
              };
            }),
          ]}
          items={ruleset.unitProfiles}
        />
      </div>
    </FauxDialogLayout>
  );
}
